import React, { memo, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import utils from '../utils';
import logoImage from '@/assets/images/login/loginTitle.png';
import rjLogoImage from '@/assets/images/login/rj_box_logo.png';
import { setLocalStorage } from '@/utils/localStorage';
import { isRJChannelPackage } from '@/components/ElectronLayout/ElectronHead/config';
const LOGIN_HISTORY_KEY = 'goBackUserName';

interface HeadBtnProps {
  headBtnType?: number;
  headBtnUser?: string;
  onGoBackPage?: () => void;
}

function LoginHeadBtn(props: HeadBtnProps) {
  const { headBtnType, headBtnUser, onGoBackPage } = props;
  const history: any = useHistory();
  const [logo, setLogo] = useState<string | null>(null);
  const onGoBack = () => {
    if (headBtnType && headBtnType === 2) {
      return history.replace('/login/account');
    }
    if (headBtnType && headBtnType === 3 && headBtnUser) setLocalStorage(LOGIN_HISTORY_KEY, headBtnUser);
    if (headBtnType && headBtnType === 4) {
      return onGoBackPage && onGoBackPage();
    }
    history.goBack();
  };

  useEffect(() => {
    setTimeout(() => {
      setLogo(isRJChannelPackage() ? rjLogoImage : logoImage);
    }, 700);
  }, []);
  
  return (
    <div className="login_header_box">
      <div className="login_header_box-operation_box">
        {headBtnType && headBtnType === 1 ? (
          <div></div>
        ) : (
          <span
            className="operation_back"
            onClick={e => {
              e.stopPropagation();
              onGoBack();
            }}
          ></span>
        )}

        <span
          className="operation_close"
          onClick={() => {
            utils.quitBox();
          }}
        ></span>
      </div>
      <img className="login_header_box-logo_box" src={logo || ''} alt="" />
    </div>
  );
}
export default memo(LoginHeadBtn);
